import {
  Box,
  Flex,
  Heading,
  IconButton,
  Image,
  Link,
  Modal,
  ModalContent,
  ModalOverlay,
  Text,
} from "@chakra-ui/core";
import React, { useRef } from "react";

import logoIcon from "../../assets/logo.png";
import { appDownloadQrCode } from "../../services/app-download.service";
import StoreBadges from "./StoreBadges";

const HEADER_GRADIENT = "linear-gradient(135deg,#3a2a1c 0%,#da1515 100%)";

// „Verzió 2 — tömör modal", QR-kóddal kiegészítve. Csak asztali nézetben
// jelenik meg (mobilon a tapadó sáv a párja): a QR-t a telefonnal beolvasva az
// `/app` köztes oldal dönti el, melyik store-ba vigyen.
function AppPromoModal({
  isOpen,
  onClose,
  onStoreClick,
}: {
  isOpen: boolean;
  onClose: () => void;
  onStoreClick: () => void;
}): JSX.Element {
  // Nyitáskor ne a bezáró gomb kapjon fókuszgyűrűt (lásd CompetitionConsentModal).
  const contentRef = useRef<HTMLElement>(null);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="490px"
      initialFocusRef={contentRef}
    >
      <ModalOverlay
        backgroundColor="rgba(10,10,10,.45)"
        className="app-promo-overlay"
      />
      <ModalContent
        ref={contentRef}
        tabIndex={-1}
        borderRadius="20px"
        overflow="hidden"
        color="#1c1c1c"
      >
        <Flex
          position="relative"
          height="104px"
          alignItems="center"
          justifyContent="center"
          backgroundImage={HEADER_GRADIENT}
        >
          <Image src={logoIcon} height="76px" width="auto" />
          <IconButton
            onClick={onClose}
            aria-label="Bezárás"
            icon="close"
            size="sm"
            position="absolute"
            top="14px"
            right="14px"
            isRound
            color="#fff"
            backgroundColor="rgba(255,255,255,.22)"
            _hover={{ backgroundColor: "rgba(255,255,255,.35)" }}
          />
        </Flex>

        <Box p="24px 28px 22px" textAlign="center">
          <Heading as="h2" fontSize="21px" lineHeight="1.25" fontWeight={800}>
            Töltsd le a Pizza Sprint appot
          </Heading>
          <Text mt="8px" fontSize="14.5px" lineHeight="1.45" color="#5a6069">
            Gyorsabb rendelés, kuponok és hűségpontok — mindig kéznél.
          </Text>

          <Flex mt="20px" alignItems="center" justifyContent="center">
            <Box
              flex="none"
              p="6px"
              mr="20px"
              borderRadius="12px"
              border="1px solid #e3e6ea"
            >
              <Image src={appDownloadQrCode()} width="112px" height="112px" />
            </Box>
            <Flex direction="column" alignItems="flex-start" textAlign="left">
              <Text fontSize="13px" lineHeight="1.4" color="#5a6069" mb="10px">
                Olvasd be a telefonod kamerájával — a megfelelő áruházba
                visz.
              </Text>
              <StoreBadges
                height="36px"
                onStoreClick={onStoreClick}
              />
            </Flex>
          </Flex>

          <Link
            as="button"
            onClick={onClose}
            display="inline-block"
            mt="18px"
            fontSize="13px"
            color="#8a9098"
            textDecoration="underline"
          >
            Most nem
          </Link>
        </Box>
      </ModalContent>
    </Modal>
  );
}

export default AppPromoModal;
